import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../config/axiosConfig";

const PerfilEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [perfil, setPerfil] = useState({ id: -1, nombre: "", permisos: [] });

    useEffect(() => {
        fetchPerfil();
    }, [id]);

    const fetchPerfil = async () => {
        try {
            const { data } = await axiosInstance.get(`/perfiles/ver/${id}`);
            setPerfil({
                id: data.data.id,
                nombre: data.data.nombre,
                permisos: data.data.permisos, // Ahora estamos esperando un array de objetos
            });
            console.log(data.data.permisos);
        } catch (error) {
            console.error("Error al obtener perfil", error);
        }
    };

    const toggleModulo = (moduloId) => {
        const permisosAct = [...perfil.permisos];
        const moduloIndex = permisosAct.findIndex(modulo => modulo.id === moduloId);

        // Determinar si el módulo está completamente seleccionado (todas las páginas tienen permiso = true)
        const estaSeleccionado = permisosAct[moduloIndex].paginas.every(pagina => pagina.permiso);

        // Actualizar todos los permisos de las páginas del módulo al valor opuesto
        permisosAct[moduloIndex].paginas = permisosAct[moduloIndex].paginas.map(pagina => ({
            ...pagina,
            permiso: !estaSeleccionado, // Cambia el estado a 'true' si estaba 'false' y viceversa
        }));

        // Actualizar el estado de los permisos
        setPerfil({ ...perfil, permisos: permisosAct });
    };


    const togglePermiso = (moduloId, paginaId) => {
        const permisosAct = [...perfil.permisos];
        const moduloIndex = permisosAct.findIndex(modulo => modulo.id === moduloId);
        const paginaIndex = permisosAct[moduloIndex].paginas.findIndex(pagina => pagina.id === paginaId);

        permisosAct[moduloIndex].paginas[paginaIndex].permiso = !permisosAct[moduloIndex].paginas[paginaIndex].permiso;

        setPerfil({ ...perfil, permisos: permisosAct });
        console.log(permisosAct);
    };

    const guardarPerfil = async () => {
        try {
            console.log(perfil);
            // Crear un arreglo que contendrá todos los ids de los módulos o páginas seleccionados
            const permisosSeleccionados = perfil.permisos.reduce((result, modulo) => {
                // Verificar si el módulo tiene el permiso activado
                if (modulo.permiso) {
                    result.push(modulo.id);  // Si el módulo tiene permiso, agregar su id
                }

                // Verificar cada página dentro del módulo
                modulo.paginas.forEach(pagina => {
                    if (pagina.permiso) {
                        result.push(pagina.id);  // Si la página tiene permiso, agregar su id
                    }
                });

                return result;
            }, []);

            // Crear un nuevo objeto perfil con los permisos seleccionados
            const perfilConPermisosSeleccionados = {
                ...perfil,
                permisos: permisosSeleccionados,  // Solo los ids de módulos o páginas con permiso = true
            };
            console.log(perfilConPermisosSeleccionados);

            await axiosInstance.post(`/perfiles/guardar`, perfilConPermisosSeleccionados);

            // Después de guardar, redirigir a la lista de perfiles
            navigate("/perfiles");
        } catch (error) {
            console.error("Error al guardar el perfil", error);
        }
    };

    return (
        <div className="container mt-4">
            <div className="card shadow">
                <div className="card-header bg-primary text-white">
                    <h4 className="mb-0">{id === "nuevo" ? "Nuevo Perfil" : `Perfil: ${perfil.nombre}`}</h4>
                </div>
                <div className="card-body">
                    <form>
                        <input type="hidden" name="id" value={perfil.id} />
                        <div className="mb-3">
                            <label className="form-label">Nombre del Perfil</label>
                            <input
                                type="text"
                                className="form-control"
                                value={perfil.nombre}
                                onChange={(e) => setPerfil({ ...perfil, nombre: e.target.value })}
                                required
                            />
                        </div>

                        <h5>Permisos</h5>
                        <div className="list-group">
                            {perfil.permisos.map((modulo) => (
                                <div key={modulo.id} className="mb-2">
                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={`mod-${modulo.id}`}
                                            checked={modulo.paginas.every(pagina => pagina.permiso)}
                                            onChange={() => toggleModulo(modulo.id)}
                                        />
                                        <label className="form-check-label fw-bold" htmlFor={`mod-${modulo.id}`}>
                                            {modulo.nombre}
                                        </label>
                                    </div>
                                    <div className="ms-4">
                                        {modulo.paginas.map((pagina) => (
                                            <div key={`${modulo.id}-${pagina.id}`} className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id={`perm-${modulo.id}-${pagina.id}`}
                                                    checked={pagina.permiso || false}
                                                    onChange={() => togglePermiso(modulo.id, pagina.id)}
                                                />
                                                <label className="form-check-label" htmlFor={`perm-${modulo.id}-${pagina.id}`}>
                                                    {pagina.nombre}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="d-flex justify-content-end mt-3">
                            <button type="button" className="btn btn-success" onClick={() => guardarPerfil()}>
                                Guardar
                            </button>
                            <button type="button" className="btn btn-secondary ms-2" onClick={() => navigate("/perfiles")}>
                                Cancelar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default PerfilEdit;
